// src/components/Curieux.jsx
import React from "react";
import "./chapter.css";

export default function Curieux() {
  return (
    <section className="chapter">
      <header className="chapter__header">
        <h2 className="chapter__title">Pour les curieux</h2>
        <p className="chapter__subtitle">
          Les curieux sont les personnes qui font avancer le monde — et vous en faites partie. Merci d’être venu comprendre pourquoi ce projet existe.
        </p>
      </header>

      <div className="chapter__content">
        <p className="chapter__intro">
          Nous vivons dans un monde de plus en plus concurrentiel, venant de l'étranger mais également localement. Mes analyses montrent qu'en moyenne tous les jours une quarantaine de sociétés se créent en Suisse romande et que (fort heureusement) en moyenne quelques-unes cessent leur activité, parfois pour s'agrandir ou fusionner. Mon coach m'a dit, lors de notre première séance : « Vendre est la seule règle qui fonctionne. Si tu ne vends pas, c'est le début de la fin. » Pour avoir été quelques années autonome, je peux vous dire qu'être actif dans son domaine, se tenir au courant de l'évolution (périodes de formations), vendre et faire du marketing le soir et la nuit finit par ruiner vie de famille et santé.
        </p>

        <div className="chapter__content">
          <h3 className="chapter__block-title">Une idée vous a-t-elle déjà traversé l’esprit ?</h3>
          <p className="chapter__block-text">
            Alors si seulement ceux qui savent où il y a un besoin et qui ne sont pas intéressés pouvaient m'informer de ces opportunités… Cela me permettrait de me concentrer sur mon savoir-faire et de récompenser ceux qui m'aident.  
            <br/>Ce projet a été créé pour cela.
          </p>
        </div>

        <div className="chapter__block">
          <h3 className="chapter__block-title">Objectif</h3>
          <p className="chapter__block-text">
            Mettre en relation ceux qui savent où il y a un besoin et ceux qui savent comment le combler.  
            Il permet, par exemple, à tout chef d'entreprise qui lors d'un meeting apprend qu'un partenaire, un sous-traitant, une connaissance a un besoin, de venir renseigner la plateforme.  
            Toute personne déclarée et possédant un numéro d'entreprise peut participer au projet. Elle peut apporter des opportunités… mais surtout en recevoir.  
            La plateforme, grâce à un moteur puissant et adaptatif, permet de mettre les personnes avec un besoin en relation avec une personne pouvant leur apporter la solution.
          </p>
        </div>

        <div className="chapter__block">
          <h3 className="chapter__block-title">Comment participer</h3>
          <p className="chapter__block-text">
            Si votre activité est dans le placement de personnes fixes ou temporaires, nous avons conçu un autre projet dédié à votre activité, pour remercier les personnes et entreprises qui m'ont aidé pendant ma période d'activité en tant que consultant.  
            Je vous invite à vous rendre sur :
            <br />
            <a href="https://coordination-emploi.ch" target="_blank" rel="noopener noreferrer">Coordination-Emploi.ch</a> <br/>— si vous avez besoin d'aide  
            <br />
            <a href="https://open-market.ch/partenaires" target="_blank" rel="noopener noreferrer">Open-Market.ch</a> <br/>— si vous êtes à la recherche de nouvelles opportunités de placement fixes ou temporaires.
           </p>
           <br/>
          <h3 className="chapter__block-title">Pour toutes les autres entreprises</h3>
          <p className="chapter__block-text">
            Les différentes options sont définies ci-dessous.
          </p>
        </div>
      </div>
    </section>
  );
}
